import BrandProfileForm from '../Screens/Brand/BrandProfileForm';
import BrandProfilePage from '../Screens/Brand/BrandProfilePage';
import useBrandProfile from '../Hooks/useBrandProfile';
export default function BrandProfileRoute() {
    const { profile, fetchProfile } = useBrandProfile();
    const handleFormSubmit = async () => {
        await fetchProfile(); // Make sure this updates the profile state
    };
    return profile?.brand ? <BrandProfilePage /> : <BrandProfileForm onSave={handleFormSubmit} />;
}
